<template>
  <f7-popup id="popup-settings" class="popup-settings">
    <f7-view>
      <f7-page>
        <f7-block-title large>Settings</f7-block-title>

        <f7-block v-if="loading" class="page-message">
          <f7-preloader></f7-preloader>
        </f7-block>

        <f7-list v-else>
          <f7-list-item>
            <span>{{ `SMS Notification. Tel: ${user.phone || '-'}` }}</span>
            <f7-toggle
              name="phoneNotify"
              :disabled="!user.phone"
              :checked="phoneNotify"
              @change="update"
            ></f7-toggle>
          </f7-list-item>

          <f7-list-item>
            <span class="display-flex flex-collumn">
              <div>{{ `Telegram Notification. Code: ${user.telegramApiKey}` }}</div>
              <div>
                Connect to
                <f7-link href="https://t.me/stillfybot" target="_blank" external>
                  @stillfybot
                </f7-link>
                then /login {{ user.telegramApiKey }}
              </div>
            </span>
            <f7-toggle
              name="telegramNotify"
              :disabled="!user.telegramChatId"
              :checked="telegramNotify"
              @change="update"
            ></f7-toggle>
          </f7-list-item>

          <f7-list-item
            v-if="timezones.length"
            smart-select
            :smart-select-params="{
              closeOnSelect: true,
              pageBackLinkText: 'Back'
            }"
          >
            <span slot="title">
              <f7-icon>🕑</f7-icon>
              Timezone
            </span>
            <select @change="changeTimezone">
              <option
                v-for="timezone in timezones"
                :key="timezone.id"
                :value="timezone.id"
                :selected="user.timezone.id === timezone.id"
              >
                {{ timezone.label }}
              </option>
            </select>
          </f7-list-item>
        </f7-list>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  name: 'PopupSettings',

  data() {
    return {
      loading: true,
      phoneNotify: false,
      telegramNotify: false,
      timezones: []
    };
  },

  computed: {
    user() {
      return this.$store.state.user.info;
    }
  },

  async created() {
    apiRequest('timezones', 'GET').then(res => {
      if (res.success) {
        this.timezones = res.success.timezones;
      }
    });

    try {
      const res = await apiRequest('settings', 'GET', null, true);
      this.loading = false;

      if (res.success) {
        const { noty_phone, noty_telegram } = res.success;

        this.phoneNotify = !!noty_phone;
        this.telegramNotify = !!noty_telegram;
      }
    } catch (error) {
      console.log(error);
      notify({ text: 'Something went wrong 🤯. Please try again.' });
      this.loading = false;
    }
  },

  methods: {
    async update(e) {
      const { name, checked } = e.target;
      this[name] = checked;
      await this.$nextTick();

      const { phoneNotify, telegramNotify } = this;
      const body = new FormData();
      body.append('noty_phone', phoneNotify ? 1 : 0);
      body.append('noty_telegram', telegramNotify ? 1 : 0);

      apiRequest('settings', 'POST', body, true);
    },

    changeTimezone(e) {
      const timezoneId = e.target.value;

      const body = new FormData();
      body.append('timezone_id', timezoneId);

      apiRequest('set/timezone', 'POST', body, true).then(res => {
        if (res.success) {
          this.$store.dispatch('user/getUserInfo');
        }
      });
    }
  }
};
</script>

<style lang="less"></style>
